/// <reference path="../../PropertyManagement/Tenants/TenantsDialog.ts" />

namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerClass()
    export class TenantsListDialog extends TenantsDialog {
        protected getFormKey() { return TenantsForm.formKey; }
        constructor() {
            super();
            this.form.PropertyId.element.hide();
        }
    }
}